// @flow
import throttle from "lodash.throttle"

export type UpdateFunction = (
  url: string,
  routerAction: Function,
  query: string,
  callback: Function
) => void

export const updateQuery: UpdateFunction = throttle(
  (url, routerAction, query, callback) => {
    routerAction(`${url}${query ? `?name=${query}` : ""}`)
    callback()
  },
  1000
)



// WEBPACK FOOTER //
// ./src/SearchTableView/helpers.js